// extracted by mini-css-extract-plugin
export default {"myModal":"MyMydal_myModal__uaNK3","active":"MyMydal_active__Gr-Jd","myModal__content":"MyMydal_myModal__content__Mh9R0","open":"MyMydal_open__cYGbD"};